const state = {
  active: true,
};

const mutations = {
  CHANGE_MBCROPPIMGCANVAS_ACTIVE(state, a) {
    state.active = a;
  },
};
const actions = {};

const getters = {
  mbCroppImgCanvasActive: (state) => {
    return state.active;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
